import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';
import { useActiveUser } from './useActiveUser';
import { useActiveAccountId } from './useActiveAccountId';
import { useActiveProjectId } from './useActiveProjectId';
import { analytics, AnalyticsEvents } from '../util/analytics';

export const useMixpanel = () => {
  const user = useActiveUser();
  const accountId = useActiveAccountId();
  const projectId = useActiveProjectId();
  const actorId = user?.id;
  const contextRef = useRef({ actorId, accountId, projectId });

  useLayoutEffect(() => {
    contextRef.current = { actorId, accountId, projectId };
  }, [actorId, accountId, projectId]);

  useEffect(() => {
    analytics.setUser(actorId);
  }, [actorId]);

  const track = useCallback(
    <Key extends keyof AnalyticsEvents>(
      name: Key,
      payload: AnalyticsEvents[Key],
    ) => {
      analytics.track(name, payload, contextRef.current);
    },
    [],
  );

  return useMemo(
    () => ({
      track,
    }),
    [track],
  );
};
